import { cn } from '@/lib/utils';
import { formatMoney } from '@/shared/lib/money';
import { ButtonSpinner } from '@/shared/components/button-spinner';
import savingsIcon from '@/features/payments/assets/icon-savings.svg';
import { savingsPercent } from '../lib/savings';

interface OfferPaymentProps {
  total: number | null;
  previousTotal?: number;
  currency?: string;
  discountPercent?: number;
  ctaLabel: string;
  ctaMuted?: boolean;
  purchasing?: boolean;
  error?: string | null;
  onCta: () => void;
}

export function OfferPayment({
  total,
  previousTotal,
  currency = 'USD',
  discountPercent,
  ctaLabel,
  ctaMuted = false,
  purchasing = false,
  error,
  onCta,
}: OfferPaymentProps) {
  const hasTotal = total != null;
  const save = hasTotal ? savingsPercent(total, previousTotal, discountPercent) : null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <span className="shrink-0 font-body text-base font-bold leading-5 text-mf-neutral-900">Total now:</span>
        <span className="h-px flex-1 bg-mf-neutral-200" />
        {hasTotal ? (
          <div className="flex flex-col items-end gap-0.5">
            <div className="flex items-center gap-1">
              {previousTotal != null && previousTotal > total && (
                <span className="relative font-body text-base font-normal leading-5 text-mf-neutral-400">
                  {formatMoney(previousTotal, currency)}
                  <span className="absolute inset-x-0 top-1/2 h-px bg-mf-error" />
                </span>
              )}
              <span className="font-body text-base font-bold leading-5 text-mf-neutral-900">
                {formatMoney(total, currency)}
              </span>
            </div>
            {save != null && save > 0 && (
              <span className="flex items-center gap-1 rounded-full bg-mf-error px-2 py-1">
                <img src={savingsIcon} alt="" className="h-3 w-2.5" />
                <span className="font-body text-[10px] font-bold leading-3 text-white">SAVE {save}%</span>
              </span>
            )}
          </div>
        ) : (
          <span className="font-body text-base font-bold leading-5 text-mf-neutral-900">—</span>
        )}
      </div>

      <button
        type="button"
        data-offer-cta
        onClick={onCta}
        disabled={purchasing}
        className={cn(
          'flex h-[52px] w-full items-center justify-center rounded-full px-5 font-body text-base font-bold leading-5 text-white transition-opacity hover:opacity-90 disabled:opacity-50',
          ctaMuted ? 'bg-mf-neutral-900/20' : 'bg-mf-green',
        )}
      >
        {purchasing ? <ButtonSpinner /> : ctaLabel}
      </button>
      {error && <p className="text-center text-sm leading-4 text-mf-error">{error}</p>}
    </div>
  );
}
